import routeHelper from "helpers/route"

export default routeHelper.lazyLoadRoute(
  () => import(/* webpackChunkName: "PageSEOHome" */ "containers/PageSEOSection/PageSEOSection"),
  "containers/PageSEOSection/PageSEOSection"
)
